/**
 * @file
 * Vendor bootstrap
 *
 * This file contains the initialization of vendors library
 */

import Vue from 'vue'

import {$} from 'simpli-web-sdk'
import './registerServiceWorker'
import 'font-awesome/css/font-awesome.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.fullscreen/Control.FullScreen.css'
import 'leaflet.fullscreen/Control.FullScreen'

import moment from 'moment'

import VueGtag from 'vue-gtag'
import VueMeta from 'vue-meta'
import VueMoment from 'vue-moment'
import VueProgress from 'vue-progress'
import Popover from 'vue-js-popover'

Vue.use(VueMeta)
Vue.use(VueMoment, {moment})
Vue.use(VueProgress)
Vue.use(Popover, {tooltip: true})

Vue.use(
  VueGtag,
  {
    config: {id: process.env.VUE_APP_GTAG_ID},
    enabled: process.env.VUE_APP_ENV === 'production',
  },
  $.router,
)
